<template>
    <transition :name="transitionName">
        <div>
            <!--电脑端-->
            <div v-if="$store.getters.current_footer != ''">
                <div v-if="isShow">
                    <el-tooltip placement="top" :content="$t('_back_top')">
                        <div v-show="up_visible" :style="left_customStyle" class="back-to-ceiling" @click="backToTop">
                            <svg width="32px" class="Icon Icon--backToTopArrow" height="32px" viewBox="0 0 17 17"
                                xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                                :style="{ 'height': '32px', 'width': '32px' }">
                                <path
                                    d="M12.036 15.59a1 1 0 0 1-.997.995H5.032a.996.996 0 0 1-.997-.996V8.584H1.03c-1.1 0-1.36-.633-.578-1.416L7.33.29a1.003 1.003 0 0 1 1.412 0l6.878 6.88c.782.78.523 1.415-.58 1.415h-3.004v7.004z" />
                            </svg>
                        </div>
                    </el-tooltip>
                    <el-tooltip placement="bottom" :content="$t('_back_bottom')">
                        <div v-show="down_visible" :style="customStyle" class="back-to-ceiling" @click="backToBottom">
                            <svg width="32px" class="Icon Icon--backToTopArrow" height="32px" viewBox="0 0 17 17"
                                xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                                :style="{ 'height': '32px', 'width': '32px', 'transform': 'scaleY(-1)' }">
                                <path
                                    d="M12.036 15.59a1 1 0 0 1-.997.995H5.032a.996.996 0 0 1-.997-.996V8.584H1.03c-1.1 0-1.36-.633-.578-1.416L7.33.29a1.003 1.003 0 0 1 1.412 0l6.878 6.88c.782.78.523 1.415-.58 1.415h-3.004v7.004z" />
                            </svg>
                        </div>
                    </el-tooltip>
                </div>
                <!--  <el-switch v-model="isShow" inactive-text="顯/隱導航" style="bottom: 153px;float: right;right:21px">
            </el-switch> -->
            </div>
            <!--手机端-->
            <div v-else>
                <div v-if="isShow">
                    <div v-show="up_visible" :style="left_customStyle" class="back-to-ceiling" @click="backToTop">
                        <svg width="32px" class="Icon Icon--backToTopArrow" height="32px" viewBox="0 0 17 17"
                            xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                            :style="{ 'height': '32px', 'width': '32px' }">
                            <path
                                d="M12.036 15.59a1 1 0 0 1-.997.995H5.032a.996.996 0 0 1-.997-.996V8.584H1.03c-1.1 0-1.36-.633-.578-1.416L7.33.29a1.003 1.003 0 0 1 1.412 0l6.878 6.88c.782.78.523 1.415-.58 1.415h-3.004v7.004z" />
                        </svg>
                    </div>
                    <div v-show="down_visible" :style="customStyle" class="back-to-ceiling" @click="backToBottom">
                        <svg width="32px" class="Icon Icon--backToTopArrow" height="32px" viewBox="0 0 17 17"
                            xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                            :style="{ 'height': '32px', 'width': '32px', 'transform': 'scaleY(-1)' }">
                            <path
                                d="M12.036 15.59a1 1 0 0 1-.997.995H5.032a.996.996 0 0 1-.997-.996V8.584H1.03c-1.1 0-1.36-.633-.578-1.416L7.33.29a1.003 1.003 0 0 1 1.412 0l6.878 6.88c.782.78.523 1.415-.58 1.415h-3.004v7.004z" />
                        </svg>
                    </div>
                </div>
                <!-- <el-switch v-model="isShow" style="bottom: 153px;float: right;right:21px">
            </el-switch> -->
            </div>
        </div>
    </transition>
</template>
 
<script>
export default {
    //name: 'BackToTop',
    props: {
        class_name: {
            type: String,
            default: ""
        },
        visibilityHeight: {
            type: Number,
            default: 400
        },
        backPosition: {
            type: Number,
            default: 0
        },
        customStyle: {
            type: Object,
            default: function () {
                return {
                    'z-index': 9999,
                    right: '25px',
                    bottom: '86px',
                    width: '50px',
                    height: '50px',
                    'border-radius': '50px',
                    'line-height': '70px',
                    background: '#e7eaf1'
                }
            }
        },
        left_customStyle: {
            type: Object,
            default: function () {
                return {
                    'z-index': 9999,
                    right: '25px',
                    bottom: '136px',
                    width: '50px',
                    height: '50px',
                    'border-radius': '50px',
                    'line-height': '70px',
                    background: '#e7eaf1'
                }
            }
        },
        transitionName: {
            type: String,
            default: 'fade'
        }
    },
    data() {
        return {
            down_visible: true,//顯示向下Icon
            up_visible: false,//顯示向上Icon
            interval: null,
            isMoving: false,
            isShow: false,//默認隱藏，滾動時顯示
            hideTimer: null,//隱藏圖標
        }
    },
    mounted() {
        // 必須加時間函數，否則頁面代碼保存後組件可能失效
        setTimeout(() => {
            if (document.getElementsByClassName(this.class_name)[0] != undefined)
                window.document.getElementsByClassName(this.class_name)[0].addEventListener('scroll', this.handleScroll)
        }, 1000);
    },
    updated() {
        setTimeout(() => {
            if (document.getElementsByClassName(this.class_name)[0] != undefined)
                document.getElementsByClassName(this.class_name)[0].addEventListener('scroll', this.handleScroll)
        }, 1000);
    },
    // 使用緩存組件後需激活頁面
    activated() {
        setTimeout(() => {
            if (document.getElementsByClassName(this.class_name)[0] != undefined)
                document.getElementsByClassName(this.class_name)[0].addEventListener('scroll', this.handleScroll)
        }, 1000);
    },
    beforeDestroy() {
        if (document.getElementsByClassName(this.class_name)[0] != undefined)
            document.getElementsByClassName(this.class_name)[0].removeEventListener('scroll', this.handleScroll)
        if (this.interval) {
            clearInterval(this.interval)
        }
    },
    methods: {
        handleScroll() {
            const scrollContainer = document.getElementsByClassName(this.class_name)[0];
            const scrollTop = scrollContainer.scrollTop; // 滚动条位置
            const clientHeight = scrollContainer.clientHeight; // 容器高度
            const scrollHeight = scrollContainer.scrollHeight; // 内容高度
            if (scrollTop + clientHeight + 1 >= scrollHeight) {
                // 滚动条已滑到最底部
                this.down_visible = false;
                this.up_visible = true;
            }
            else if(scrollTop <= 1) {
                // 滚动条已滑到最頂部
                this.down_visible = true;
                this.up_visible = false;
            }
            else{
                this.down_visible = true;
                this.up_visible = true;
            }
            // 不滾動時3秒隱藏
            this.isShow = true;
            clearTimeout(this.hideTimer);
            if (this.isShow) {
                this.hideTimer = setTimeout(() => {
                    this.isShow = false;
                }, 3000);
            }
            this.$store.commit("set_main_top", scrollTop);
        },
        // 返回顶部
        backToTop() {
            //document.querySelector('.el-card').scrollTop = 0;
            if (this.isMoving) return
            const start = document.getElementsByClassName(this.class_name)[0].scrollTop
            let i = 0
            this.isMoving = true
            this.interval = setInterval(() => {
                const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500))
                if (next <= this.backPosition) {
                    document.getElementsByClassName(this.class_name)[0].scrollTo(0, this.backPosition - 250)
                    clearInterval(this.interval)
                    this.isMoving = false
                    this.up_visible = false;    //滾動到最頂部，不顯示向上的Icon
                } else {
                    document.getElementsByClassName(this.class_name)[0].scrollTo(0, next)
                }
                i++
            }, 16.7)
        },
        // 返回底部
        backToBottom() {
            if (this.isMoving) return;
            const container = document.getElementsByClassName(this.class_name)[0];
            const start = container.scrollTop;
            const end = container.scrollHeight - container.clientHeight;
            let i = 0;
            this.isMoving = true;
            this.interval = setInterval(() => {
                const next = Math.floor(this.easeInOutQuad(10 * i, start, end - start, 500));
                if (next >= end - this.backPosition) {
                    container.scrollTo(0, end + 250);
                    clearInterval(this.interval);
                    this.isMoving = false;
                    this.down_visible = false;    //滾動到最底部，不顯示向下的Icon
                } else {
                    container.scrollTo(0, next);
                }
                i++;
            }, 16.7);
        },
        easeInOutQuad(t, b, c, d) {
            if ((t /= d / 2) < 1) return c / 2 * t * t + b
            return -c / 2 * (--t * (t - 2) - 1) + b
        },
    },
}
</script>

<style scoped>
.back-to-ceiling {
    position: fixed;
    display: inline-block;
    text-align: center;
    cursor: pointer;
}

.back-to-ceiling:hover {
    background: #d5dbe7;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0
}

.back-to-ceiling .Icon {
    fill: #9aaabf;
    background: none;
}
</style>
